<template>
    <div class="seotable-box">
        <div class="table-box">
            <h3 class="caption">{{tableData.caption}}</h3>
            <div class="table-item-box">
                <ul class="table-ul">
                    <li class="table-li" v-for='(item,index) in tableData.uldata' :key='index'>
                        <span class="number">{{'0'+(index+1)}}</span>
                        <div class="centnt">
                            <h5 class="title">{{item.title}}</h5><span class="entitle">{{item.entitle}}</span>
                        </div>
                    </li>
                </ul>
                <div class="sometitle" v-html='tableData.someTitle'></div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'SeoTable',
        data() {
            return {
                tableData: {
                    caption: 'SEO优化明细',
                    someTitle: '<p>按照以上的SEO检查项目逐一优化，让搜索引擎更容易的抓取收录您的网站。</p><p>利用搜索引擎的规则提高网站在有关搜索引擎内的自然排名，获取高质量询盘。</p>',
                    uldata: [
                        {
                            title: '网站标题优化',
                            entitle: 'Title optimization'
                        },
                        {
                            title: '网站描述优化',
                            entitle: 'Meta description optimization'
                        },
                        {
                            title: 'H1,H2,H3标签优化',
                            entitle: 'H1,H2,H3 tags optimization'
                        },
                        {
                            title: '内外链优化',
                            entitle: 'Internal linking &External linking'
                        },
                        {
                            title: '结构化数据制作',
                            entitle: 'Schema markup for google rich snippets'
                        },
                        {
                            title: '分析工具安装',
                            entitle: 'Analytics setup'
                        },
                        {
                            title: '网站速度优化',
                            entitle: 'Website speed optimization'
                        }
                    ]
                }
            }
        }
    }
</script>
<style scoped>
    .seotable-box {
        margin: 220px 0 165px 0;
    }

    .table-box {
        width: 71%;
        min-height: 697px;
        border: 2px solid #333333;
        padding: 8% 5%;
        margin: 0 auto;
    }

    .table-box {
        display: flex;
        justify-content: space-between;
    }

    .table-item-box {
        width: 716.5px;
    }

    .table-li,
    .centnt {
        display: flex;
        align-items: center;
    }

    .table-li:not(:first-child) {
        padding-top: 28px;
    }

    .centnt {
        border-bottom: 1px solid #707070;
        padding-bottom: 11px;
        justify-content: space-between;
        flex-grow: 1;
    }

    .number {
        display: inline-block;
        width: 19px;
        width: 18px;
        font-size: 16px;
        font-weight: bold;
        color: rgba(36, 136, 248, 1);
        padding-bottom: 11px;
        margin-right: 15px;
    }

    .caption {
        font-size: 16px;
        font-weight: bold;
        line-height: 32px;
        color: rgba(51, 51, 51, 1);
    }

    .title {
        font-size: 16px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
    }

    .entitle {
        font-size: 16px;
        font-weight: 400;
        color: rgba(204, 204, 204, 1);
    }

    .sometitle {
        margin-top: 49px;
    }

    .sometitle>>>p {
        font-size: 16px;
        font-weight: 400;
        line-height: 32px;
        color: rgba(112, 112, 112, 1);
    }

    @media(max-width: 1460px) {
        .table-item-box {
            width: 80%;
        }
    }

    @media(max-width: 995px) {
        .seotable-box {
            margin: 10% 0;
        }

        .table-box {
            width: 90%;
            min-height: auto;
            border: 1px solid #333333;
            padding: 8% 5%;
            margin: 0 auto;
            flex-direction: column;
            align-items: center;
        }

        .table-item-box {
            width: 100%;
        }

        .centnt {
            flex-direction: column;
            align-items: flex-start;
        }
    }

    /* @media(max-width: 1023px) {
        .table-box {
            width: 90%;
            padding: 5%;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        .table-item-box {
            margin-top: 10%;
            width: 100%;
        }

        .caption {
            font-size: 65px;
            line-height: 100%;
        }

        .number {
            display: inline-block;
            width: 55px;
            font-size: 50px;
            padding-right: 6%;
        }

        .title {
            font-size: 50px;
        }

        .entitle {
            font-size: 50px;
        }

        .sometitle>>>p {
            text-align: center;
            font-size: 42px;
            line-height: 200%;
        }
    }
    @media(max-width: 355px){
        .table-box {
            width: 100%;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/project/seotable.vue